import firebase from 'firebase/app';
import 'firebase/auth'
import 'firebase/database'
import 'firebase/messaging'
import 'firebase/firestore'
import 'firebase/functions'

import { FirebaseConfig } from "../config/keys";

firebase.initializeApp(FirebaseConfig);


export const databaseRef = firebase.database().ref()

export const serverTimestamp = firebase.database.ServerValue.TIMESTAMP

export const usersRef = databaseRef.child("users")
export const productsRef = databaseRef.child("products")
export const usersUnitsRef = databaseRef.child("usersUnits")

export const sportsRef = databaseRef.child("sports")
export const participantsRef = databaseRef.child("participants/sports")
export const sportEventsRef = databaseRef.child("sportEvents/sports")

export const premiumBetsRef = databaseRef.child("bets/premium")
export const usersBetsRef = databaseRef.child("bets/users")

export const freeBetPageRef = databaseRef.child("freeBetPage")

export const betVideosRef = databaseRef.child("betVideos")

export const ordersRef = databaseRef.child("orders")

export const subscribersRef = databaseRef.child("activeSubs")

export const fcmSubscriptionsRef = databaseRef.child("fcmSubscriptions")

//// CLOUD FUNCTIONS 
export const cloudFunction = firebase.app().functions('us-central1')

//// FIREBASE AUTH
export const authRef = firebase.auth();
export const provider = new firebase.auth.GoogleAuthProvider();
export const providerFacebook = new firebase.auth.FacebookAuthProvider();

/// FCM (FIREBASE CLOUD MESSAGING)
/// try

let firebaseMessaging = null
if (firebase.messaging.isSupported()) {
   firebaseMessaging = firebase.messaging()

}
export { firebaseMessaging }




//FIRESTORE
export const firestoreRef = firebase.firestore()
const settings = {timestampsInSnapshots: true};
firestoreRef.settings(settings);

export const packagesRef = firestoreRef.collection("packages")
export const betsRef = firestoreRef.collection("bets")
export const betsAvrageRef = firestoreRef.collection("betsAvrage")
export const betsWeeklyRef = firestoreRef.collection("betsWeekly")
export const betsMonthlyRef = firestoreRef.collection("betsMonthly")



// WEBPACK FOOTER //
// ./src/config/firebase.js